<template>
  <span class="block" :class="{ 'child-slide-up-active': inView }">
    <slot></slot>
  </span>
</template>

<script>
import Vue from 'vue'
import SplitText from 'gsap/SplitText'

import inViewMixin from '../../mixins/in-view'

export default {
  name: 'SplitTextAnimation',
  mixins: [inViewMixin],
  data() {
    return {
      st: null,
    }
  },
  methods: {
    split() {
      this.st.split()
      this.afterSplit()
    },
    afterSplit() {
      this.$el.querySelectorAll('.js-line').forEach((line, i) => {
        line.querySelectorAll('.slide-up-animation').forEach((el) => {
          el.style.setProperty('--index-delay', `${i * 150}ms`)
        })
      })
    },
  },
  mounted() {
    window.addEventListener('resize', this.split)
    Vue.nextTick(() => {
      this.st = new SplitText(this.$el, {
        type: 'lines,words',
        linesClass: 'overflow-hidden -mb-[0.1em] js-line',
        wordsClass: 'slide-up-animation translate-y-full',
      })
      this.afterSplit()
    })
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.split)
  },
}
</script>